export enum LandingPageTab {
  Onboarding = 'onboarding',
  Training = 'training',
}

//  This value refers to the taskId of the userTasks
export enum UserTask {
  PortalWelcomeExperienceTask = 5,
}
